/**
 * Utilidad para limpiar sesiones de Supabase
 * Ejecuta esta función en la consola del navegador para limpiar sesiones corruptas
 */

export const clearSupabaseSessions = () => {
  console.log('🧹 Iniciando limpieza de sesiones de Supabase...');
  
  try {
    // Limpiar localStorage
    const localStorageKeys = Object.keys(localStorage);
    let localStorageCleared = 0;
    
    localStorageKeys.forEach(key => {
      if (key.includes('supabase') || key.includes('sb-') || key.includes('auth')) {
        localStorage.removeItem(key);
        localStorageCleared++;
        console.log(`🗑️ Eliminado de localStorage: ${key}`);
      }
    });
    
    // Limpiar sessionStorage
    const sessionStorageKeys = Object.keys(sessionStorage);
    let sessionStorageCleared = 0;
    
    sessionStorageKeys.forEach(key => {
      if (key.includes('supabase') || key.includes('sb-') || key.includes('auth')) {
        sessionStorage.removeItem(key);
        sessionStorageCleared++;
        console.log(`🗑️ Eliminado de sessionStorage: ${key}`);
      }
    });
    
    // Limpiar cookies relacionadas con Supabase
    const cookies = document.cookie.split(';');
    let cookiesCleared = 0;
    
    cookies.forEach(cookie => {
      const [name] = cookie.split('=');
      const trimmedName = name.trim();
      
      if (trimmedName.includes('supabase') || trimmedName.includes('sb-') || trimmedName.includes('auth')) {
        document.cookie = `${trimmedName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        cookiesCleared++;
        console.log(`🍪 Eliminada cookie: ${trimmedName}`);
      }
    });
    
    console.log(`✅ Limpieza completada:`);
    console.log(`   - localStorage: ${localStorageCleared} elementos eliminados`);
    console.log(`   - sessionStorage: ${sessionStorageCleared} elementos eliminados`);
    console.log(`   - cookies: ${cookiesCleared} elementos eliminados`);
    
    // Recargar la página después de 2 segundos
    console.log('🔄 Recargando página en 2 segundos...');
    setTimeout(() => {
      window.location.reload();
    }, 2000);
    
  } catch (error) {
    console.error('❌ Error durante la limpieza:', error);
  }
};

// Función para verificar el estado del reloj del sistema
export const checkSystemClock = () => {
  const now = new Date();
  const utcTime = now.getTime();
  const localTime = now.getTimezoneOffset() * 60000;
  
  console.log('🕐 Verificación del reloj del sistema:');
  console.log(`   - Hora local: ${now.toLocaleString()}`);
  console.log(`   - UTC: ${new Date(utcTime).toISOString()}`);
  console.log(`   - Offset de zona horaria: ${now.getTimezoneOffset()} minutos`);
  
  // Verificar si hay una diferencia significativa
  const timeDiff = Math.abs(utcTime - (utcTime + localTime));
  if (timeDiff > 300000) { // Más de 5 minutos de diferencia
    console.warn('⚠️ Posible problema de sincronización de tiempo detectado');
    console.log('💡 Recomendación: Sincroniza el reloj de tu sistema');
  } else {
    console.log('✅ Reloj del sistema parece estar sincronizado');
  }
};

// Función para mostrar información de depuración
export const debugSupabaseSession = () => {
  console.log('🔍 Información de depuración de Supabase:');
  
  // Mostrar todas las claves de localStorage
  const localStorageKeys = Object.keys(localStorage);
  const supabaseKeys = localStorageKeys.filter(key => 
    key.includes('supabase') || key.includes('sb-') || key.includes('auth')
  );
  
  console.log('📦 Claves de Supabase en localStorage:');
  supabaseKeys.forEach(key => {
    try {
      const value = localStorage.getItem(key);
      console.log(`   ${key}: ${value ? value.substring(0, 100) + '...' : 'null'}`);
    } catch (error) {
      console.log(`   ${key}: [Error al leer]`);
    }
  });
  
  // Mostrar cookies
  const cookies = document.cookie.split(';');
  const supabaseCookies = cookies.filter(cookie => {
    const [name] = cookie.split('=');
    return name.trim().includes('supabase') || name.trim().includes('sb-') || name.trim().includes('auth');
  });
  
  console.log('🍪 Cookies de Supabase:');
  supabaseCookies.forEach(cookie => {
    console.log(`   ${cookie.trim()}`);
  });
  
  if (supabaseKeys.length === 0 && supabaseCookies.length === 0) {
    console.log('ℹ️ No se encontraron datos de sesión de Supabase');
  }
};

// Función principal que ejecuta todas las verificaciones
export const diagnoseSupabaseIssues = () => {
  console.log('🔧 Diagnóstico completo de Supabase...');
  console.log('='.repeat(50));
  
  checkSystemClock();
  console.log('');
  
  debugSupabaseSession();
  console.log('');
  
  console.log('💡 Para limpiar sesiones, ejecuta: clearSupabaseSessions()');
  console.log('💡 Para recargar la página, ejecuta: window.location.reload()');
};

// Hacer las funciones disponibles globalmente
if (typeof window !== 'undefined') {
  (window as any).clearSupabaseSessions = clearSupabaseSessions;
  (window as any).checkSystemClock = checkSystemClock;
  (window as any).debugSupabaseSession = debugSupabaseSession;
  (window as any).diagnoseSupabaseIssues = diagnoseSupabaseIssues;
  
  // Solo mostrar en desarrollo
  if (process.env.NODE_ENV === 'development') {
    console.log('🛠️ Utilidades de Supabase cargadas. Ejecuta:');
    console.log('   - diagnoseSupabaseIssues() para diagnóstico completo');
    console.log('   - clearSupabaseSessions() para limpiar sesiones');
    console.log('   - checkSystemClock() para verificar el reloj del sistema');
  }
} 